import LineClampTypography from 'src/components/common/ui/LineClampTypography';
import { FlexColumnContainer } from 'src/components/styles';
import { Address } from 'src/types/common';

interface AddressLabelProps {
  address: Address;
}

export default function AddressLabel({ address }: AddressLabelProps) {
  return (
    <FlexColumnContainer textAlign="start" mb={0.6}>
      <LineClampTypography
        content={address.name.replace(/^Direccion de /, '')}
        disableFulltextToggle
        typographyProps={{
          textTransform: 'capitalize',
          maxWidth: '350px',
        }}
      />
      <LineClampTypography
        typographyProps={{
          color: 'InactiveCaptionText',
          lineHeight: 1,
          variant: 'caption',
          maxWidth: '350px',
        }}
        content={`${address.address.street_name} ${address.address.street_number}`}
        lines={1}
        disableFulltextToggle
      />
    </FlexColumnContainer>
  );
}
